module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAZElEQVQ4y2NgGBTgvbbuf3LwEDDgo4cmGJNtwLdmRTAm2YDPKar/f58U///nohgYg9ggMZwGMMzz/I+OvdZawQ0AsbGpwWtA+TbD/927dMEYxCbZALklzljZRBtAFKaeAUMaAABuKUxeq/O92gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/BF.png
// module id = 1088
// module chunks = 0